// Плитка иконки (D-27, §2.4).
// Source: docs/specs/design-revision/d-design-system.md §2.4.
//
// Мягкая подложка со значком внутри. На одном лендинге она встречалась в
// трёх размерах и двух скруглениях (56/16, 40/9, 48/16), плюс свои варианты
// в Профиле (36), на пустой Главной (44) и в кнопке загрузки (36). Размер —
// из фиксированного набора, скругление одно на все размеры.

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const SIZE = {
  sm: 'h-9 w-9',    /* 36 */
  md: 'h-11 w-11',  /* 44 */
  lg: 'h-14 w-14',  /* 56 */
} as const;

const TONE = {
  /** Зелёная подложка — основной случай. */
  primary: 'bg-primary/10 text-primary-text',
  /** На цветной подложке: белое полупрозрачное поверх зелёного блока. */
  inverse: 'bg-white/20 text-white',
  /** Нейтральный — там, где значок не про статус. */
  muted: 'bg-muted text-muted-foreground',
} as const;

export function IconTile({
  size = 'md',
  tone = 'primary',
  className,
  children,
}: {
  size?: keyof typeof SIZE;
  tone?: keyof typeof TONE;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        'inline-flex flex-shrink-0 items-center justify-center rounded-control',
        SIZE[size],
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
